/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { getFullQuote, fetchLocations } from '../../../actions'

/**
 * Import
 * - Page component
 */
import EditQuote from '../../../components/pages/Quote/EditQuote/EditQuote'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        riskLocations: state.quote.riskLocations,
        isCollectors: get(state, 'quote.full.response.quote.isCollectors', true),
        isMuseums: get(state, 'quote.full.response.quote.isMuseums', true),
        isDealersStock: get(state, 'quote.full.response.quote.isDealersStock', true),
        isWineSpirits: get(state, 'quote.full.response.quote.isWineSpirits', true),
        isWineSpiritsSteve: get(state, 'quote.full.response.quote.isWineSpiritsSteve', false),
    }
}

export default connect(
    mapStateToProps,
    {
        quote: 'The QUOTE! EditQuote',
        getFullQuote: getFullQuote,
        fetchLocations,
    }
)(EditQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/EditQuote.tsx